"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var url_search_params_1 = __importDefault(require("@ungap/url-search-params"));
/**
 * A Helper class which simplifies some complex request setups as like fetch
 * with POST and Content-Type 'application/x-www-form-urlencoded'.
 *
 * @class HTTPUtil
 */
var HTTPUtil = /** @class */ (function () {
    function HTTPUtil() {
    }
    /**
     * A method that performs a fetch request with some predefined configs.
     *
     * @param {Object} Options The options object to configure the post request.
     *  It can contain theses keys:
     *    {String} url The url we want to send the post to.
     *    {Object} params The post params we want to send.
     *      Default is {}.
     *    {Object} additionalHeaders An object with additional headers as kvp.
     *      Default is {}.
     *    {Object} additionalFetchOptions An object containing additional options
     *      for the fetch API. Compare https://mdn.io/fetch Default is {}.
     *    {Boolean} sameOriginCredentials A flag to wether set the credentials
     *      option to 'same-origin' or let it undefined. Default is true.
     *    {Boolean} asForm A flag to set the Content-Type header to
     *      'application/x-www-form-urlencoded'. Default is true.
     */
    HTTPUtil.post = function (optionsObject) {
        return __awaiter(this, void 0, void 0, function () {
            var url, _a, params, _b, additionalHeaders, _c, additionalFetchOptions, _d, sameOriginCredentials, _e, asForm, headers, options;
            return __generator(this, function (_f) {
                url = optionsObject.url, _a = optionsObject.params, params = _a === void 0 ? {} : _a, _b = optionsObject.additionalHeaders, additionalHeaders = _b === void 0 ? {} : _b, _c = optionsObject.additionalFetchOptions, additionalFetchOptions = _c === void 0 ? {} : _c, _d = optionsObject.sameOriginCredentials, sameOriginCredentials = _d === void 0 ? true : _d, _e = optionsObject.asForm, asForm = _e === void 0 ? true : _e;
                headers = new Headers();
                if (asForm) {
                    headers.set('Content-Type', 'application/x-www-form-urlencoded');
                }
                Object.keys(additionalHeaders).forEach(function (headerKey) {
                    var headerValue = additionalHeaders[headerKey];
                    headers.set(headerKey, headerValue);
                });
                options = __assign({ method: 'POST', credentials: sameOriginCredentials ? 'same-origin' : undefined, body: asForm ? new url_search_params_1.default(params) : params, headers: headers }, additionalFetchOptions);
                return [2 /*return*/, fetch(url, options)];
            });
        });
    };
    return HTTPUtil;
}());
exports.default = HTTPUtil;
//# sourceMappingURL=HTTPUtil.js.map